// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","parrafo":"Footer_parrafo__2rp3c"};